if (!customElements.get('country-switcher-popup')) {
  const { Fancybox } = await import('@fancyapps/ui');

  class CountrySwitcherPopup extends HTMLElement {
    constructor() {
      super();

      let searchUrl = location.search;
      this.anchors = this.querySelectorAll('a');
      this.anchors.forEach((anchor) => {
        let currentUrl = anchor.href;
        let newUrl = currentUrl + searchUrl;
        anchor.href = newUrl;
      });

      this.target = this.querySelector('[data-country-switcher-popup-target]').innerHTML;
      this.triggers = document.querySelectorAll('[data-country-switcher-popup-trigger]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.openPopup.bind(this));
      });
    }

    openPopup() {
      new Fancybox([
        {
          src: this.target,
          type: 'html',
          autoFocus: false,
          fullscreen: {
            autoStart: true,
          },
        },
      ]);

      let d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 30);
      document.querySelectorAll('[data-country-iso]').forEach((iso) => {
        iso.addEventListener('click', (event) => {
          event.preventDefault;
          let isoCode = iso.dataset.countryIso;
          document.cookie =
            'code-user-location-new' +
            '=' +
            isoCode +
            ';path=/;domain=.alpinestars.com;expires=' +
            d.toGMTString();
          let url = iso.href;
          location.href = url;
        });
      });
    }
  }

  window.CountrySwitcherPopup = CountrySwitcherPopup;

  customElements.define('country-switcher-popup', CountrySwitcherPopup);
}
